const riot = require('riot');

riot.tag2('page-recorder', '<div class="f fclm s-full"> <div class="s-full" ref="recorder" data-is="module-recorder" projects="{projects}" templates="{templates}"></div> <div data-is="module-tabbar"></div> </div>', '', '', function(opts) {
    this.preload = async ({req, res}) => {
      if (spat.isNode) return;

      var promises = [
        app.store.collection('projects').fetch({ relation: true }),
        app.store.collection('users').doc(app.store.currentUser.id).collection('templates').fetch({ relation: true }),
        app.store.collection('records')
          .where('created_user_ref', '==', app.store.currentUser.ref)
          .where('is_recording', '==', true)
          .fetch({ relation: true }),

      ];

      var [projects, templates, activeRecord] = await Promise.all(promises);

      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);
      templates = this.sortTemplates(templates);

      return {
        projects: projects,
        templates,
        activeRecord: activeRecord[0],

      };
    };
    this.on('show', () => {
      this.intervalId = setInterval(() => {
        this.update();
      }, 1000);

      this.refs.recorder.setup(this.activeRecord);
    });

    this.on('hide', () => {
      clearInterval(this.intervalId);
    });

    this.sortTemplates = (items) => {
      var templates = items.sort((a, b) => {
        var a_name = a.relation.project && a.relation.project.doc.exists ? a.relation.project.data.name.toLowerCase() : '';
        var b_name = b.relation.project && b.relation.project.doc.exists ? b.relation.project.data.name.toLowerCase() : '';
        if (a_name === b_name) {
          return 0;
        }
        return a_name < b_name ? -1 : 1;
      });

      return templates;
    };
});